/*
   * browser-state specific endpoints
   */
import axios from "../../fetch-api/fetch-api";

export function saveRecentlyViewedProductApi(sku: string) {
  return axios.post("/add-recently-viewed-product-v3", { sku });
}
